import React from "react";

import { Checkbox, FormGroup, FormControlLabel } from "@mui/material";

const Resources = (props) => {
  const { resources, onChange, type } = props;
  return (
    <FormGroup>
      {Object.entries(resources).map(([key, value], index) => {
        if (value.type === type) {
          return (
            <FormControlLabel
              key={Math.random()}
              control={
                <Checkbox
                  checked={value.checked}
                  name={value.name}
                  onChange={(e) => onChange(e, index)}
                />
              }
              label={value.label}
            />
          );
        }
      })}
    </FormGroup>
  );
};

export default Resources;
